import {gql} from "@apollo/client";



export const UpdateVmsBoardsConnectivityStatus = gql`
  mutation UpdateVmsBoardsConnectivityStatus(
    $token: String!
    $customerID: ID!
    $user_details: SubscribedUser!
  ) {
    UpdateVmsBoardsConnectivityStatus(
      token: $token
      customerID: $customerID
      user_details: $user_details
    )
  }
`;
